export default "__VITE_ASSET__CZRjUjbG__"